import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Button from '@atoms/Button';
import { ButtonOutlineLarge } from '@styled';
import { GlobalModalContext } from '@context/globalModalContext';

export const useDeleteCartItemModal = () => {
    const [, setIsModalOpen, setModalChildren] = useContext(GlobalModalContext);

    const openModal = (title, onDelete = () => {}) => {
        setModalChildren(
            DeleteCartItemModal({
                closeModal: () => setIsModalOpen(false),
                title,
                onDelete: () => {
                    setIsModalOpen(false);
                    onDelete();
                },
            })
        );

        setIsModalOpen(true);
    };

    return { openModal };
};

const DeleteCartItemModal = ({ closeModal, title = '', onDelete }) => (
    <>
        <h3 className="my-3">Remove this item</h3>
        <p>Are you sure you want to remove {title}?</p>
        <div className="d-flex mt-2">
            <Button buttonClasses="deletecartitem mr-3" onClick={onDelete}>
                Delete Now
            </Button>
            <ButtonOutlineLarge onClick={closeModal}>Cancel</ButtonOutlineLarge>
        </div>
    </>
);

DeleteCartItemModal.propTypes = {
    title: PropTypes.string,
    onDelete: PropTypes.func,
    closeModal: PropTypes.func,
};

export default DeleteCartItemModal;
